import { render, staticRenderFns } from "./Use-AppSumo-Code.vue?vue&type=template&id=c4f5f638&scoped=true&"
import script from "./Use-AppSumo-Code.vue?vue&type=script&lang=js&"
export * from "./Use-AppSumo-Code.vue?vue&type=script&lang=js&"
import style0 from "./Use-AppSumo-Code.vue?vue&type=style&index=0&id=c4f5f638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f5f638",
  null
  
)

export default component.exports